import {Box,Container,Stack,Typography} from "@mui/material";
import {Link} from "react-router-dom";
import logo from "../static/logo2.webp";

const navItems=[
  {label:"Inicio",path:"/"},
  {label:"Torneos",path:"/torneos"},
  {label:"Partidos",path:"/torneos/nexus-cup-2026/calendario"}
];

export default function Footer(){
  return(
    <Box
      component="footer"
      sx={{
        width:"100%",
        backgroundColor:"#06132D",
        color:"#FFFFFF",
        borderTop:"1px solid rgba(255,255,255,.08)"
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          px:{xs:2.5,sm:4,md:5,lg:7},
          pt:{xs:4,md:5},
          pb:{xs:3,md:3.5}
        }}
      >
        <Stack
          direction={{xs:"column",md:"row"}}
          alignItems="center"
          justifyContent="space-between"
          spacing={{xs:3,md:4}}
        >
          <Box
            component={Link}
            to="/"
            aria-label="Ir al inicio de TORNEOS"
            sx={{
              display:"inline-flex",
              alignItems:"center",
              textDecoration:"none"
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="TORNEOS"
              sx={{
                width:"auto",
                height:{xs:55,md:65},
                maxWidth:190,
                objectFit:"contain"
              }}
            />
          </Box>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            useFlexGap
            flexWrap="wrap"
            spacing={0}
            sx={{
              columnGap:{xs:2.5,sm:3.5},
              rowGap:1.5
            }}
          >
            {navItems.map(item=>(
              <Box
                key={item.path}
                component={Link}
                to={item.path}
                sx={{
                  color:"rgba(255,255,255,.78)",
                  fontSize:{xs:13,sm:14},
                  fontWeight:400,
                  textDecoration:"none",
                  transition:"color .2s ease",
                  "&:hover":{
                    color:"#FFFFFF"
                  }
                }}
              >
                {item.label}
              </Box>
            ))}
          </Stack>
        </Stack>

        <Box
          sx={{
            mt:{xs:4,md:4.5},
            pt:2.5,
            borderTop:"1px solid rgba(255,255,255,.12)",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
          }}
        >
          <Typography
            sx={{
              color:"rgba(255,255,255,.60)",
              fontSize:{xs:11,sm:12},
              fontWeight:400,
              textAlign:"center",
              lineHeight:1.7
            }}
          >
            © {new Date().getFullYear()} TORNEOS. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}